/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module GslbModule
 */

import { Injector } from '@angular/core';

import {
    GslbGeoDbProfileCollection,
    TGslbGeoDbProfileCollection,
} from 'ajs/modules/gslb/factories/gslb-geodb-profile/gslb-geodb-profile.collection.factory';

import {
    GSLBServiceCollection,
    TGSLBServiceCollection,
} from 'ajs/modules/gslb/factories/gslb-service/gslb-service.collection.factory';

import { GSLB_GEODB_PROFILE_COLLECTION_TOKEN } from 'ajs/modules/gslb/gslb.tokens';

const $injector = '$injector';

export const gslbGeoDbProfileCollectionProvider = {
    deps: [$injector],
    provide: GslbGeoDbProfileCollection,
    useFactory(injector: Injector): TGslbGeoDbProfileCollection {
        return injector.get(GSLB_GEODB_PROFILE_COLLECTION_TOKEN);
    },
};

export const gslbServiceCollectionProvider = {
    deps: [$injector],
    provide: GSLBServiceCollection,
    useFactory(injector: Injector): TGSLBServiceCollection {
        return injector.get('GSLBServiceCollection');
    },
};
